import base64UrlEncode from 'hero-utils/base64UrlEncode';
const genRandomString = (length = 75) => {
    const arr = window.crypto.getRandomValues(new Uint32Array(28));
    const string = Array.from(arr, (dec) => ('0' + dec.toString(16)).substr(-2)).join('');
    return base64UrlEncode(string).substr(0, length);
};
export default genRandomString;
//# sourceMappingURL=index.js.map